import React, { useState, useEffect } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import CrudSection from "view/settings/masterdata/CrudSection";
import { useGetMasterDataListQuery } from "store/slices/apis/masterDataApiSlice";
import CustomTabs from "components/CustomTabs";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const masterDataModules = [
    { label: "Action Tracker", path: "action-tracker" },
    { label: "Claims", path: "claim" },
    { label: "Changes", path: "change" },
    { label: "Compliance", path: "compliance" },
    { label: "Design & Eng.", path: "design-engineering" },
    { label: "EHS", path: "ehs-finding" },
    { label: "Financial BG", path: "financial-bg" },
    { label: "HSE", path: "hse" },
    { label: "Invoice", path: "invoice" },
    { label: "Leads", path: "leads" },
    { label: "Legal", path: "legal-compliance" },
    { label: "NCR Log", path: "ncr-log" },
    { label: "Operating Cost", path: "operating-cost" },
    { label: "Procurement", path: "procurement" },
    { label: "Risk", path: "risk" },
    { label: "Statutory", path: "statutory-approval" },
    { label: "Workflow", path: "workflow" },
    { label: "Warehousing", path: "warehousing" },
    { label: "Rail", path: "rail" },
    { label: "Commercial", path: "commercial" },
    { label: "Insurance", path: "insurance" },
];

const MasterData = ({ pageTitle, sections }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const { projectId } = useParams();

    const [selectedSection, setSelectedSection] = useState(sections[0]?.value || "");

    const selectedData = sections.find(
        (sec) => sec.value === selectedSection
    ) || sections[0];

    const { data: apiResponse, isLoading, isError } = useGetMasterDataListQuery({
        module: pageTitle,
        category: selectedData?.value,
    });

    const list = Array.isArray(apiResponse?.data) ? apiResponse.data : [];

    const items = list.map(item => item.value);

    useEffect(() => {
        if (sections?.length > 0) {
            setSelectedSection(sections[0].value);
        }
    }, [sections]);

    const selectedTab = Math.max(0, sections.findIndex((section) => section.value === selectedSection));
    const activeModule = Math.max(0, masterDataModules.findIndex((module) => location.pathname.endsWith(`/settings/masterdata/${module.path}`)));
    const handleTabChange = (_event, index) => setSelectedSection(sections[index]?.value || "");
    const handleModuleChange = (_event, index) => {
        const path = masterDataModules[index]?.path;
        if (path) navigate(`/projects/${projectId}/settings/masterdata/${path}`);
    };

    return (

        <Box>

            <Box sx={{ px: 2, py: 1.75, backgroundColor: "#FFFFFF", borderBottom: "1px solid #E2E8F0" }}>
                <Typography sx={{
                    fontWeight: 650,
                    fontSize: "20px",
                    lineHeight: "27px",
                    letterSpacing: "0px",
                    color: "#0F172A",
                    fontFamily: "Outfit, sans-serif"
                }}>
                    {pageTitle} Master Data
                </Typography>
                <Typography sx={{ mt: 0.2, fontSize: "12px", lineHeight: "17px", color: "#64748B" }}>
                    Manage reference values used across {pageTitle.toLowerCase()} workflows.
                </Typography>
            </Box>

            <Box sx={{ px: 2, py: 1, backgroundColor: "#F8FAFC", borderBottom: "1px solid #E2E8F0", overflow: "hidden" }}>
                <Tabs
                    value={activeModule}
                    onChange={handleModuleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    TabIndicatorProps={{ style: { display: "none" } }}
                    sx={{ minHeight: 34, "& .MuiTabs-flexContainer": { gap: 0.75 }, "& .MuiTabs-scrollButtons": { width: 30, color: "#475569" } }}
                >
                    {masterDataModules.map((module, index) => (
                        <Tab
                            key={module.path}
                            label={module.label}
                            sx={{
                                minWidth: "auto",
                                minHeight: 32,
                                px: 1.25,
                                py: 0.6,
                                borderRadius: "3px",
                                border: `1px solid ${activeModule === index ? "#BFDBFE" : "transparent"}`,
                                bgcolor: activeModule === index ? "#EAF2FF" : "transparent",
                                color: activeModule === index ? "#2563EB" : "#64748B",
                                fontSize: 11,
                                fontWeight: activeModule === index ? 650 : 550,
                                textTransform: "none",
                            }}
                        />
                    ))}
                </Tabs>
            </Box>

            <Box sx={{ px: 2, backgroundColor: "#FFFFFF" }}>
                <CustomTabs tabValue={selectedTab} handleTabChange={handleTabChange} tabs={sections} />
            </Box>

            <CrudSection
                module={pageTitle}
                category={selectedData?.value}
                label={selectedData?.label}
                isLoading={isLoading}
                rawData={list}
                defaultItems={items}
            />

        </Box>
    );
};

export default MasterData;
